import { CategoriesLargeList } from './CategoriesLargeList';
import { LargeRectangleGrid } from './LargeRectangleGrid';
import { HorizantalList } from './HorizantalList';
import { CircleList } from './CircleList';
import { LargeRectangleList } from './LargeRectangleList';
import { BaseComponentProps } from '../helpers/contentHooks';
import { FeaturedContent } from './FeaturedContent';
import { WajeezCard } from './WajeezCard';
import { WajeezOffer } from './WajeezOffer';
import { CategoriesSeeAllList } from './CategoriesSeeAllList';
import { CategoriesGrid } from './CategoriesGrid';

export const componentRegistration: {
  [key: string]: (props: BaseComponentProps) => JSX.Element | null;
} = {
  'COM:REPEATED:FEATUREDCONTENT': FeaturedContent,
  'COM:LARGE:RECTANGLE:GRID': LargeRectangleGrid,
  'COM:LARGE:RECTANGLE:LIST': LargeRectangleList,
  'COM:CATEGORIES:LARGE:LIST': CategoriesLargeList,
  'COM:HORIZONTAL:LIST': HorizantalList,
  'COM:REPEATED:PODCASTGRID': HorizantalList,
  'COM:CIRCLE:LIST': CircleList,
  'COM:WAJEEZ:CARD': WajeezCard,
  'COM:WAJEEZ:OFFER': WajeezOffer,
  'COM:CATEGORIES:SEEALL:LIST': CategoriesSeeAllList,
  'COM:REPEATED:CATEGORYGRID': CategoriesGrid,
  'COM:REPEATED:BOOKGRID': HorizantalList,
  log: (p) => {
    return <p></p>;
  },
};

const ComponentSelector = (props: BaseComponentProps) => {
  if (props.component?.type === undefined) return null;
  return componentRegistration[props.component.type]?.({
    ...props,
  });
};

export default ComponentSelector;
